import React, { useState } from "react";
import Layout from "../components/Layout";
import {
    ExamStudentAllRecordList,
    getExamStudentAllMonitorList,
    getExamStudentAllMonitorListProps
} from "../../../../service/exam";
import InvigilationProvider from "../context";
import InvigilationTable from "./components/InvigilationTable";
import InvigilationSearch from "./components/InvigilationSearch";
import useRequestFn from "../../../../utils/useRequestFn";
import useSelection from "../../../../utils/v2/useSelection";
import { useToggle } from "react-use";
import { useParams } from "react-router-dom";

export default function InvigilationList() {
    const rowSelection = useSelection();
    const { examId: defaultExamId } = useParams();

    const [examId, setExamId] = useState("");
    const [query, setQuery] = useState<getExamStudentAllMonitorListProps>({
        examId: "",
        studentName: ""
    });

    const [data, setData] = useState<ExamStudentAllRecordList>({
        conditionQueryList: [],
        dataList: []
    });
    const [getList, { loading }] = useRequestFn(getExamStudentAllMonitorList);
    const [tableKey, toggleTableKey] = useToggle(false);
    async function search(
        params: getExamStudentAllMonitorListProps | undefined
    ) {
        if (params) {
            await setQuery(params);
        }
        const prop = params || query;
        const res = await getList({
            ...prop,
            isOldInvigilation: defaultExamId ? "1" : ""
        });
        await setData(res);
        await rowSelection.setSelected([]);
        await toggleTableKey();
    }

    const searchBar = (
        <InvigilationSearch
            defaultExamId={defaultExamId}
            examId={query.examId}
            data={data?.dataList}
            onSearch={search}
            stuNos={rowSelection.selected as string[]}
        />
    );

    return (
        <InvigilationProvider
            examList={data?.conditionQueryList || []}
            dataSource={data?.dataList || []}
            examId={examId}
            setExamId={setExamId}>
            <Layout
                showTab={false}
                title="监考列表"
                searchBar={searchBar}
                table={
                    <InvigilationTable
                        key={JSON.stringify(tableKey)}
                        dataSource={data?.dataList || []}
                        loading={loading}
                        onChange={() => search(query)}
                        rowSelection={rowSelection}
                    />
                }
                showRight={false}
            />
        </InvigilationProvider>
    );
}
